import { actionTypes } from './action-types';

export const maintenanceActions = {
  setMaintenanceFlags: (payload: boolean) => ({
    type: actionTypes.SET_MAINTENANCE_FLAGS,
    payload,
  }),
  clearMaintenanceFlags: () => ({
    type: actionTypes.CLEAR_MAINTENANCE_FLAGS,
  }),
};

type Actions = typeof maintenanceActions;
export type MaintenanceActions = ReturnType<Actions[keyof Actions]>;
